import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderVariables = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 19,
	viewBox: "0 0 22 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.925 17.6251H2.625C2.09457 17.6251 1.58586 17.4144 1.21079 17.0393C0.835714 16.6642 0.625 16.1555 0.625 15.6251V2.6251C0.625 2.09466 0.835714 1.58596 1.21079 1.21088C1.58586 0.83581 2.09457 0.625096 2.625 0.625096H6.605C6.93949 0.621817 7.26945 0.702485 7.5647 0.859716C7.85995 1.01695 8.11104 1.24572 8.295 1.5251L8.955 2.7251C9.13711 3.00163 9.38503 3.22862 9.6765 3.3857C9.96798 3.54278 10.2939 3.62504 10.625 3.6251H18.625C19.1554 3.6251 19.6641 3.83581 20.0392 4.21088C20.4143 4.58596 20.625 5.09466 20.625 5.6251V8.9251",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.625 17.625C14.625 17.625 13.625 16.625 13.625 14.625C13.625 12.625 14.625 11.625 14.625 11.625",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.625 11.625C18.625 11.625 19.625 12.625 19.625 14.625C19.625 16.625 18.625 17.625 18.625 17.625",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.625 13.625L15.625 15.625",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.625 13.625L17.625 15.625",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFolderVariables;
